import { render, staticRenderFns } from "./items-type-rr.vue?vue&type=template&id=ea31e9b4&scoped=true&"
import script from "./items-type-rr.vue?vue&type=script&lang=js&"
export * from "./items-type-rr.vue?vue&type=script&lang=js&"
import style0 from "./items-type-rr.vue?vue&type=style&index=0&id=ea31e9b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea31e9b4",
  null
  
)

export default component.exports